module.exports = __webpack_public_path__ + "media/luxury-2026/modern-pool-drone-960-5f83b15a.jpg";